import classNames from 'classnames';
import { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';

// Components.
import { DashboardBanner } from './DashboardBanner';

// Store.
import { IDashboardBanner } from 'store/dashboard/types';
import { isJASelector } from 'store/user/selectors';

// Styles.
import styles from './DashboardBanners.module.scss';

interface IDashboardBannersProps {
  banners: IDashboardBanner[];
  className?: string;
}

export const DashboardBanners = (props: IDashboardBannersProps): ReactElement => {
  const { banners = [], className } = props;
  const isJa: boolean = useSelector(isJASelector);
  const filteredBanners = useMemo(() => banners.filter((banner) => (isJa ? banner.isJa : !banner.isJa)), [
    isJa,
    banners,
  ]);

  return (
    banners?.length > 0 && (
      <section className={classNames(styles.banners, className)}>
        <ul>
          {filteredBanners.map((banner) => (
            <li key={banner.id}>
              <DashboardBanner banner={banner} />
            </li>
          ))}
        </ul>
      </section>
    )
  );
};
